import {
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_CLEAR_FILTERS,
  REPORTED_INCIDENTS_SET_FORM,
} from '../../../actions/actionTypes';

const defaultState = null;

const form = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REPORTED_INCIDENTS_CLEAR:
    case REPORTED_INCIDENTS_CLEAR_FILTERS:
      return defaultState;

    case REPORTED_INCIDENTS_SET_FORM:
      return payload?.form;

    default:
      return state;
  }
};

export default form;
